import React from "react";
import MainConvert from "../Component/Converter";

const Converter = () => {
	return <MainConvert />;
};

export default Converter;
